// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* Add your styles here */\n.menu-section[data-v-6b4b1594] {\n  margin-bottom: 20px;\n}\n.menu-item[data-v-6b4b1594] {\n  margin-bottom: 10px;\n}\ninput[data-v-6b4b1594] {\n  margin-left: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
